import { useState, useEffect } from "react";
import moment from "moment-timezone";

const getTimeZoneAbbreviation = () => {
  try {
    const timeZone = moment.tz.guess(); // Get full timezone name
    const abbreviation = new Intl.DateTimeFormat("en-US", {
      timeZone,
      timeZoneName: "short",
    })
      .formatToParts(new Date())
      .find((part) => part.type === "timeZoneName")?.value;
    const short_abbreviation = moment.tz(timeZone).format("z"); // Get standard abbreviation

    console.log("Detected Timezone:", timeZone);
    console.log("Detected Timezone Abbreviation:", abbreviation);
    console.log("Detected Timezone Abbreviation:", short_abbreviation);

    return abbreviation || "Unknown";
  } catch (error) {
    console.error("Error fetching timezone abbreviation:", error);
    return "Unknown";
  }
};
// Custom hook for device compatibility and size tracking
const useDeviceTracking = (minWidth = 768) => {
  const [deviceData, setDeviceData] = useState({
    width: typeof window !== "undefined" ? window.innerWidth : 0,
    height: typeof window !== "undefined" ? window.innerHeight : 0,
    isCompatible: true,
    deviceType: "unknown",
    orientation: "unknown",
    lastUpdate: new Date().toISOString(),
    sizeHistory: [],
  });
  const [isClient, setIsClient] = useState(false);

  const getDeviceType = (width) => {
    if (width < 640) return "mobile";
    if (width < 768) return "small-tablet";
    if (width < 1024) return "tablet";
    if (width < 1280) return "laptop";
    return "desktop";
  };

  const logSizeChange = (newData) => {
    console.group("Screen Size Change Detected");
    console.log("Timestamp:", new Date().toLocaleTimeString());

    console.log(getTimeZoneAbbreviation());

    console.log("New Width:", newData.width);
    console.log("New Height:", newData.height);
    console.log("Device Type:", newData.deviceType);
    console.log("Orientation:", newData.orientation);
    console.log("Is Compatible:", newData.isCompatible);
    console.groupEnd();
  };

  useEffect(() => {
    setIsClient(true);

    const updateDeviceData = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const deviceType = getDeviceType(width);
      const orientation = width > height ? "landscape" : "portrait";
      const isCompatible = width >= minWidth;

      const newData = {
        width,
        height,
        isCompatible,
        deviceType,
        orientation,
        lastUpdate: new Date().toISOString(),
        sizeHistory: [
          ...deviceData.sizeHistory.slice(-4), // Keep last 5 changes
          {
            timestamp: new Date().toISOString(),
            width,
            height,
            deviceType,
          },
        ],
      };

      setDeviceData(newData);
      logSizeChange(newData);
    };

    // Initial check
    updateDeviceData();

    // Debounced resize handler
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateDeviceData, 250); // Debounce for 250ms
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", updateDeviceData);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", updateDeviceData);
    };
  }, [minWidth]);

  if (!isClient) return { ...deviceData, isCompatible: true };

  return deviceData;
};

export default useDeviceTracking;
